import React, { Fragment, useState } from 'react';
import { DELETE } from 'ra-core';
import { Button, useDataProvider, useTranslate, useRecordContext } from 'react-admin';
import MUIButton from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import ErrorIcon from '@mui/icons-material/Error';
import CheckIcon from '@mui/icons-material/CheckCircle';
import { useSnackbar } from 'notistack';
import { FUNCTION_URL } from '../../../Constants/index';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

function CustomDeleteButton () {
    const [isOpen, setIsOpen] = useState();
    const dataProvider = useDataProvider();
    const translate = useTranslate();
    const {enqueueSnackbar} = useSnackbar();
    const record = useRecordContext();

    const handleClick = () => {
        setIsOpen(true);
    }

    const handleDialogClose = () => {
        setIsOpen(false);
    };

    const handleConfirm = async () => {
        setIsOpen(false);
        let workrequestid = record.workrequestid;
        let requestingDevice = record.serial_number_tim;

        await dataProvider(DELETE, 'devices', { id: record.id })
            .then(
                response => {
                    if (response.data.error) {
                        //Ex: Invalid cast Id
                        console.log(response.data.error.message);
                        enqueueSnackbar(translate('tim.delete.error'), {
                            variant: 'error',
                            anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'center',
                            },
                            autoHideDuration: 3000,
                        });
                    }
                    else if (response.data.message && response.data.message === "Deleted") {
                        enqueueSnackbar(translate('tim.delete.deleted'), {
                            variant: 'success',
                            anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'center',
                            },
                            autoHideDuration: 3000,
                        });

                        fetch(FUNCTION_URL + '/recoverwr/' + workrequestid, {
                            method: 'PUT',
                            headers: {
                                'Content-Type': 'text/plain',
                                'x-zumo-auth': localStorage.getItem('auth-token')
                            },
                            body: JSON.stringify({ serial_number_tim: requestingDevice })
                        })
                            .catch(error => {
                                console.log(error);
                            });
                        window.location.replace(window.location.origin + '/#/devices');
                    }
                })
            .catch(error => {
                console.log(error);
                enqueueSnackbar(translate('tim.delete.error'), {
                    variant: 'error',
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'center',
                    },
                    autoHideDuration: 3000,
                });
            });
    };

        return (
            <Fragment>
                <MUIButton label='tim.delete.button_label' onClick={handleClick} color="red">
                    <DeleteIcon />
                    {translate('tim.delete.button_label')}
                </MUIButton>
                <Dialog
                    open={isOpen}
                    onClose={handleDialogClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{translate('tim.delete.title', { name: record.serial_number_tim })}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {translate('tim.delete.content')}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleDialogClose} label='tim.delete.cancel' color="primary" autoFocus>
                            <ErrorIcon />
                        </Button>
                        <Button onClick={handleConfirm} label='tim.delete.confirm' color="primary" autoFocus>
                            <CheckIcon />
                        </Button>
                    </DialogActions>
                </Dialog>
            </Fragment>
        );
}

export default CustomDeleteButton;